import {CountryDto} from "../client/catalog/CatalogApiClient";
import {createContext} from "react";

const CountryContext = createContext<CountryDto[]>([]);

export default CountryContext;